import Api from "~/service/Api";

class TourUpgradeRequestRepository {
  create(tourId, data) {
    return Api.post(`/tour/upgrade-requests/${tourId}`, data);
  }
}

export default TourUpgradeRequestRepository;
